/**
 * The Websocket configuration.
 */
import {LogLevel} from "../Domain/Logger/Logger";
import SubViewTypes from "../Domain/Types/SubViewTypes";

/**
 * The server url.
 */
export const SERVER_URL = "/api";

/**
 * The timing in milliseconds to check for the
 * power client and proxy connection statuses.
 */
export const CONNECTION_STATUS_TIMINGS_MILLISECONDS = {
    interval: 60000, // How often to check.
    duration: Infinity, // How long to check.
    indicatorDuration: 1500, // How long to display the loading indicator for.
}

/**
 * The timing in milliseconds to auto logout.
 */
export const AUTO_LOGOUT_TIMINGS_MILLISECONDS = {
    duration: 5 * 60 * 1000, // How long before auto logout. Default is 5 minutes.
}

/**
 * How long before the info message in the modal disappears.
 */
export const MODAL_INFO_MESSAGE_MILLISECONDS = 1800;

/**
 * Flag to use dummy data for the power client.
 */
export const POWER_CLIENT_USE_DUMMY_DATA = false;

/**
 * Flag to use dummy data for the power proxy.
 */
export const POWER_PROXY_USE_DUMMY_DATA = false;

/**
 * Hides the menu after an option was selected.
 */
export const HIDE_MENU_AFTER_SELECTION = false;

/**
 * Populates the power clients list with empty fields.
 */
export const ADD_DUMMY_POWER_CLIENTS = false;

/**
 * The starting page.
 */
export const START_PAGE = SubViewTypes.PowerClient;

/**
 * Show menu on start.
 */
export const SHOW_MENU_ON_START = true;

/**
 * Websocket Parameters.
 */
export const WEBSOCKET = {
    disabled: false,
    ipAddress: window.location.hostname,
    portNumber: 5010,
    postfix: '',
    reconnectMilliseconds: 5000,
};

export const WEBSOCKET_URL = `ws://${WEBSOCKET.ipAddress}:${WEBSOCKET.portNumber}/${WEBSOCKET.postfix}`;

/**
 * Sets the current log level.
 */
export const LOG_LEVEL = LogLevel.Warn;
